export default __webpack_public_path__ + "static/media/home-interior-design-testimonial-img01.f841d830.jpg";